/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Embed_CopiedInputs */

const en_admin_embed_copied = /** @type {(inputs: Admin_Embed_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copied!`)
};

const de_admin_embed_copied = /** @type {(inputs: Admin_Embed_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiert!`)
};

/**
* | output |
* | --- |
* | "Copied!" |
*
* @param {Admin_Embed_CopiedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_embed_copied = /** @type {((inputs?: Admin_Embed_CopiedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Embed_CopiedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_embed_copied(inputs)
	return en_admin_embed_copied(inputs)
});